const text = `
<h5>第一条 保险合同成立、生效和保险责任开始</h5>
<p>投保人提出保险申请、保险公司同意承保，合同成立，合同成立日期在保险单上载明。</p>
<p>自合同成立、保险公司收取首期保险费并签发保险单的次日零时起合同生效，合同生效日期在保险单上载明。生效对应日、保单年度均以该日期计算。</p>
<p>除另有约定外，合同生效的日期为保险公司开始承担保险责任的日期。</p>

<h5>第二条 首期后保险费的交付、宽限期间及合同效力中止</h5>
<p>分期交付保险费的，首期保险费后的年交、半年交、季交或月交保险费的交付日期分别为合同年生效对应日、半年生效对应日、季生效对应日或月生效对应日。</p>
<p>投保人未按上述规定日期交付保险费的，自次日起六十日为宽限期间；在宽限期间内发生保险事故，保险公司仍承担保险责任；超过宽限期间仍未交付保险费的，合同效力自宽限期间届满的次日起中止。在合同效力中止期间，保险公司不承担保险责任。</p>

<h5>第三条 合同效力恢复（复效）</h5>
<p>在合同效力中止之日起二年内，投保人可填写复效申请书，并提供被保险人的健康声明书或二级以上（含二级）医院出具的体检报告书，申请恢复合同效力。经保险公司与投保人协商并达成协议，自投保人补交所欠的保险费及利息、借款及利息的次日起，合同效力恢复。</p>
<p>自合同效力中止之日起二年内双方未达成协议的，保险公司有权解除合同，并向投保人退还合同的现金价值。</p>

<h5>第四条 明确说明与如实告知</h5>
<p>订立合同时，保险公司应向投保人明确说明合同的内容。对保险条款中免除保险公司责任的条款，保险公司在订立合同时应当在投保单、保险单或者其他保险凭证上作出足以引起投保人注意的提示，并对该条款的内容以书面或者口头形式向投保人作出明确说明。</p>
<p>保险公司可以就投保人、被保险人的有关情况提出询问，投保人应当如实告知。申请恢复合同效力时，投保人应如实告知被保险人当时的健康状况。</p>
<p>投保人故意或者因重大过失未履行前款规定的如实告知义务，足以影响保险公司决定是否同意承保或者提高保险费率的，保险公司有权解除合同。</p>
<p>前款规定的合同解除权，自保险公司知道有解除事由之日起，超过三十日不行使而消灭。自合同成立之日起超过二年的，保险公司不得解除合同；发生保险事故的，保险公司承担给付保险金的责任。</p>
<p>投保人故意不履行如实告知义务的，保险公司对于合同解除前发生的保险事故，不承担给付保险金的责任，并不退还保险费。</p>
<p>投保人因重大过失未履行如实告知义务，对保险事故的发生有严重影响的，保险公司对于合同解除前发生的保险事故，不承担给付保险金的责任，但退还保险费。</p>
<p>保险公司在合同订立时已经知道投保人未如实告知的情况的，保险公司不得解除合同；发生保险事故的，保险公司承担给付保险金的责任。</p>

<h5>第五条 受益人</h5>
<p>合同包含身故保险责任的，被保险人或投保人可指定一人或数人为身故保险金受益人。</p>
<p>除合同另有指定外，合同约定的除身故保险金外的其他保险金的受益人为被保险人本人。</p>
<p>受益人为数人的，可以确定受益顺序和受益份额；未确定受益份额的，受益人按照相等份额享有受益权。</p>
<p>被保险人为无民事行为能力人或限制民事行为能力人的，可以由其监护人指定受益人。</p>
<p>被保险人或投保人可以变更身故保险金受益人，但需书面通知保险公司，由保险公司在保险单或其他保险凭证上批注或者附贴批单。</p>
<p>投保人指定或变更身故保险金受益人时须经被保险人同意。</p>
<p>被保险人身故后，有下列情形之一的，保险金作为被保险人的遗产，由保险公司依照《中华人民共和国继承法》的规定履行给付保险金的义务：</p>
<p>（1）没有指定受益人，或者受益人指定不明无法确定的；</p>
<p>（2）受益人先于被保险人身故，没有其他受益人的；</p>
<p>（3）受益人依法丧失受益权或者放弃受益权，没有其他受益人的。</p>
<p>受益人与被保险人在同一事件中身故，且不能确定身故先后顺序的，推定受益人身故在先。</p>
<p>受益人故意造成被保险人死亡、伤残、疾病的，或者故意杀害被保险人未遂的，该受益人丧失受益权。</p>

<h5>第六条 保险事故的通知</h5>
<p>投保人、被保险人或受益人知道保险事故发生后，应及时通知保险公司。若因故意或者因重大过失未及时通知，致使保险事故的性质、原因、损失程度等难以确定的，保险公司对无法确定的部分，不承担给付保险金的责任，但保险公司通过其他途径已经及时知道或者应当及时知道保险事故发生的除外。</p>

<h5>第七条 保险金的申请与给付</h5>
<p>一、保险金申请时，由受益人作为申请人，填写保险金给付申请书，并提供合同利益条款所列的保险金申请所需证明和资料。</p>
<p>上述证明和资料不完整的，保险公司将及时一次性通知申请人补充提供有关证明和资料。</p>
<p>二、保险公司收到申请人的保险金给付申请书及上述证明和资料后，将及时作出核定；情形复杂的，将在三十日内作出核定，但合同另有约定的除外。经核定后确定属于保险责任的，保险公司在与申请人达成给付保险金的协议后十日内，履行给付保险金的义务；不属于保险责任的，保险公司将自作出核定之日起三日内向申请人发出拒绝给付保险金通知书，并说明理由。</p>
<p>保险公司自收到申请人的保险金给付申请书及上述证明和资料之日起六十日内，对属于保险责任而给付保险金的数额不能确定的，根据已有证明和资料，按可以确定的数额先予支付，保险公司最终确定给付保险金的数额后，支付相应的差额。</p>
<p>三、人寿保险的申请人向保险公司请求给付保险金的诉讼时效期间为五年，自其知道或者应当知道保险事故发生之日起计算。人寿保险以外的其他保险的申请人，向保险公司请求给付保险金的诉讼时效期间为二年，自其知道或者应当知道保险事故发生之日起计算。</p>
<p>一款保险产品的核心部分就是保险的相关条款，这也是投保人最看重的地方，是要了解清楚的，慧择向您推荐以下产品，供您参考。</p>
`;

export default text;